module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/tag-8851576c68cfa8219cf3ab73f3c085e2.svg";